import omit from 'lodash/omit';
import keys from 'lodash/keys';
import isEqual from 'lodash/isEqual';

export const objectDifference = <T extends object>(obj: T, other: object): Partial<T> => {
    return omit(
        obj,
        keys(obj).filter(key => isEqual(obj[key as keyof T], other[key as keyof object])),
    );
};
